/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

interface StatusProps {
  status?: 'A' | 'I' | 'B';
}

const StatusVariations = {
  A: css`
    background: var(--green);
  `,
  I: css`
    color: var(--purple);
    background: var(--gray-line);
  `,
  B: css`
    background: var(--red);
  `,
};

export const ModalContent = styled.div`
  height: 250px;
  width: 600px;
  padding: 0px 15px 30px 15px;
  text-align: center;
  p {
    padding-bottom: 10px;
  }
`;

export const ModalContentBanner = styled.div`
  height: 300px;
  width: 500px;
  padding: 0px 10px 20px 10px;
  text-align: center;
  h2 {
    font-weight: 14px;
  }
  p {
    font-weight: 12px;
    padding-bottom: 10px;
  }
`;

export const LinkModal = styled.a`
  text-decoration: underline;
  color: var(--purple) !important;
  width: 50px;
  height: auto;
  cursor: pointer;
  :hover {
    color: var(--orange)
  }
  padding-right: 5px;
`;

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
  }

  .TitleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 29px;

    @media only screen and (max-width: 768px) {
      margin-top: -25px;
      justify-content: center;
    }
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;

  color: var(--orange);

  align-items: center;
  justify-content: space-between;
`;

export const ButtonsContainer = styled.h1`
  .buttonsInitial {
    display: flex;
    justify-content: flex-end;
    button {
      width: 180px;
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      transition: background 0.3s ease;
    }
    .saldo {
      border: 2px solid var(--purple);
      color: var(--purple);
      background-color: transparent;
      &:hover {
        background: var(--purple);
        color: var(--white);
      }
    }
    .csv {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
    }
    .pdf {
      color: var(--white);
      border: 2px solid var(--purple);
      &:hover {
        background: var(--white);
        color: var(--purple);
      }
    }
    @media only screen and (max-width: 768px) {
      margin-top: 10px;
      justify-content: center;
    }
    @media only screen and (max-width: 767px) {
      margin-top: 0px;
      justify-content: center;
    }
  }
`;

export const StatusRow = styled.div<StatusProps>`
  color: var(--white);
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  ${props => StatusVariations[props.status || 'A']}
`;

export const FiltersContainer = styled.div`
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;
  @media only screen and (max-width: 767px) {
    margin-top: 100px;
  }

  .filter {
    margin-right: 5px;
    button {
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;

      &:hover {
        background: #9ea1a2;
      }
    }
  }

  .search {
    width: 100%;
    form {
      position: relative;
    }
    div {
      height: 40px;
      margin-top: -4px;
      input {
        font-size: 18px;
      }
    }
    .searchButton {
      position: absolute;
      right: 0px;
      top: 0;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;

      &:hover: {
        background: red;
      }
    }
  }
  .buttonsContainer {
    display: flex;
    button {
      width: 120px;
      font-size: 0.9rem;
      border-radius: 17px 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      transition: background 0.3s ease;
    }
    .clearFilters {
      width: 145px;
      border-radius: 5px;
      margin-left: 5px;
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;
      background-color: var(--aside-background);

      &:hover {
        background: #9ea1a2;
      }
    }
  }
`;

export const Block = styled.div`
  button {
    align-items: center;
    color: var(--orange);
    background: transparent;
    justify-content: center;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  Form {
    margin-top: 20px;
  }

  input {
    height: 40px;
  }
  .btn-wrapper {
    margin-top: 30px;
    display: flex;
    width: 100%;
    button {
      width: inherit;
    }

    .btn-cancelar {
      color: #757575;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      margin-right: 20px;
    }
  }
  .bloqueados {
    margin-bottom: 60px;
  }
`;
